import _startsWith from 'lodash/startsWith';

const MEMBER_AVATAR = '/static/img/avatar-member';
const TEAM_AVATAR = '/static/img/avatar-team';

export default function isDefaultAvatar(url) {
	return !url || _startsWith(url, MEMBER_AVATAR) || _startsWith(url, TEAM_AVATAR);
}
